import { render, staticRenderFns } from "./new_password_form.vue?vue&type=template&id=17dc791f&scoped=true"
import script from "./new_password_form.vue?vue&type=script&lang=ts"
export * from "./new_password_form.vue?vue&type=script&lang=ts"
import style0 from "./new_password_form.vue?vue&type=style&index=0&id=17dc791f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dc791f",
  null
  
)

export default component.exports